import { route } from '@md/routing';
import { receivedCargoesApi } from '@md/delivery/api';
import { accessPermission } from '@md/users/permissions';
import {
  DELIVERY_RECEIVED_CARGO_VIEW_LIST,
  DELIVERY_RECEIVED_CARGO_VIEW,
  DELIVERY_RECEIVED_CARGO_CREATE,
} from '@md/delivery/accessTokens';
import { receiveRoute } from '@sections/cabinet/components/views/utils';

const List = () => import('./views/List');
const Edit = () => import('./views/Edit');
const Create = () => import('./views/Create');
const EditParcel = () => import('./views/Parcels/Edit');
const Mix = () => import('./views/Mix');
const OperatorServices = () => import('./views/OperatorServices');
// manager service confirmation queue
const ServiceConfirmations = () => import('./views/ServiceConfirmations');

const RECEIVED_CARGOES_PREFIX = 'cabinet:delivery:received-cargoes:';
const p = name => RECEIVED_CARGOES_PREFIX + name;
export const LIST = p('list');
export const EDIT = p('edit');
export const CREATE = p('create');
export const EDIT_PARCEL = p('edit-parcel');
export const SERVICE_CONFIRMATIONS = p('service-confirmations');
export const MIX = p('mix');
export const OPERATOR_SERVICES = p('operator-services');

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(DELIVERY_RECEIVED_CARGO_VIEW_LIST, options),
    }),
    route(
      'service-confirmations/',
      ServiceConfirmations,
      SERVICE_CONFIRMATIONS,
      {
        meta: accessPermission(
          DELIVERY_RECEIVED_CARGO_VIEW_LIST,
          options
        ),
      }
    ),
    // physical operator service execution workspace.
    // Route meta оставляем на существующем access token;
    // STOCKMAN_OPERATOR / superuser дополнительно проверяются внутри view,
    // как уже делается для manager service confirmations / MIX.
    route(
      'operator-services/',
      OperatorServices,
      OPERATOR_SERVICES,
      {
        meta: accessPermission(
          DELIVERY_RECEIVED_CARGO_VIEW_LIST,
          options
        ),
      }
    ),
    route(
      'parcel/:id/edit/',
      EditParcel,
      EDIT_PARCEL,
      {
        meta: accessPermission(
          DELIVERY_RECEIVED_CARGO_VIEW,
          options
        ),
      }
    ),
    receiveRoute(receivedCargoesApi.retrieve, [
      route('edit/', Edit, EDIT, {
        meta: accessPermission(DELIVERY_RECEIVED_CARGO_VIEW, options),
      }),
      { path: '', redirect: { name: EDIT } },
    ]),
    route('create/', Create, CREATE, {
      meta: accessPermission(DELIVERY_RECEIVED_CARGO_CREATE, options),
    }),
    route(
      'mix/', Mix, MIX,
      {
        meta: accessPermission(
          DELIVERY_RECEIVED_CARGO_VIEW_LIST,
          options
        ),
      }
    ),

    { path: '', redirect: { name: LIST } },
  ];
}
